document.writeln(
    `
    <nav id="navBarControl" class="nav collapsible">
        <a class="nav__brand" href="/">
          <div class="nav__container">
            <p>Kwench</p>
          </div>
        </a>
        <div>
          <div id="collapsibleControl" class="nav__toggler align__horizontal">
            <a href="#" id="searchToggle_mobile"
              ><i class="fa fa-search facustom--item" aria-hidden="false"></i
            ></a>
            <a href="#"
              ><i class="fa fa-user facustom--item" aria-hidden="false"></i
            ></a>
            <div class="cartStatusContainer">
              <a href="#"
                ><i
                  class="fa fa-shopping-bag facustom--item"
                  aria-hidden="false"
                ></i
              ></a>
              <p id="cartCounter"><sup></sup></p>
            </div>
            <a href="#" id="navBarToggler"
              ><i
               class="fa fa-align-justify facustom_nav--item"
               aria-hidden="false"
              ></i
            ></a>
          </div>
        </div>
        <ul id="navBarContent" class="list nav__list collapsible__content">
          <li class="nav__item"><a href="#">Shop</a></li>
          <li class="nav__item">
            <a href="#">Ingredient Catalog</a>
          </li>
          <li class="nav__item"><a href="#">FAQ's</a></li>
          <li class="nav__item"><a href="#">About</a></li>
          <li class="nav__item nav_search_container" id="searchContainer">
            <div>
              <input
                type="text"
                id="searchBox"
                name="searchBox"
                class="search__control"
                placeholder="Looking for something specific? ..."
              />
              <a href="#" id="searchBarToggle"
                ><i
                  class="fa fa-angle-right facustom--item--secondary"
                  aria-hidden="false"
                ></i
              ></a>
            </div>
          </li>
          <li class="nav__item nav__item--link">
            <div class="">
              <a href="#" id="searchToggle"
                ><i class="fa fa-search facustom--item" aria-hidden="false"></i
              ></a>
              <a href="#"
                ><i class="fa fa-user facustom--item" aria-hidden="false"></i
              ></a>
              <a href="#"
                ><i
                  class="fa fa-shopping-bag facustom--item"
                  aria-hidden="false"
                ></i
              ></a>
            </div>
          </li>
        </ul>
      </nav>
    `
)